<template>
  <div>
    <header1 title="新手帮助"></header1>
    <div class="new_content">
      <div class="use_xieyi" style="color:#666666;">
        <div class="use_xieyi_main">
          <div class="use_xieyi" style="color:#666666;">
            <div class="use_xieyi_main"><br>
              <p class="pddpdd2"><strong style="font-size:16px;">1.为什么用手机号登录不成功？</strong></p>
              <p class="pddpdd2">
                手机号需成功验证后才可做为帐号登录。验证手机号需登录后，点右上角头像下拉菜单→帐号设置→手机验证验证，进行验证设置。</p>
              <br>
              <p class="pddpdd2"><strong style="font-size:16px;">2.忘记密码怎么办？</strong></p>
              <p class="pddpdd2">
                可点击登录框下方的忘记密码，通过已验证的手机号找回密码；也可通过关注微信公众号找回密码。</p>
              <p class="pddpdd_img"><img height="325" src="../assets/img-4/weixin_findpwd.jpg" width="714"></p><br>
              <p class="pddpdd2"><strong style="font-size:16px;">3.怎样修改密码？</strong></p>
              <p class="pddpdd2">
                登录后，鼠标放在右上角个人信息处，有修改密码快捷选项；也可通过帐号设置快捷键，进入修改密码页面进行密码修改。</p>
              <br>
              <p class="pddpdd2"><strong style="font-size:16px;">4.为什么要绑定学习卡？</strong></p>
              <p class="pddpdd2">
                为了不遗漏课程的学习、顺利申请学分及避免学习卡丢失，建议您登录学习中心后先进行学习卡绑定操作（若您手里没有学习卡可不用进行这项操作）。</p>
              <br>
              <p class="pddpdd2"><strong style="font-size:16px;">5.为什么注册不了帐号？</strong></p>
              <p class="pddpdd2">①确认证件号是否已被使用；<br>
                ②确认手机号是否已被使用；<br>
                ③确认是否已按注册要求完整填写个人信息；<br>
                ④您可能已注册过，请尝试用证件号或手机号登录；<br>
                ⑤若上述均确认没问题，但还是注册不成功，可咨询在线客服或是电话400-822-2055。</p><br>
              <p class="pddpdd2"><strong style="font-size:16px;">6.如何开始课程学习？</strong></p>
              <p class="pddpdd2">登录后，点击进入学习中心，可在我的培训栏看到相应培训班的课程，点击课程即可开始学习。</p>
              <br>
              <p class="pddpdd_img"><img height="607" src="../assets/img-4/study_load.jpg" width="788"></p><br>
              <p class="pddpdd2"><strong style="font-size:16px;">7.如何判断课程是否已完成学习？</strong></p>
              <p class="pddpdd2">课程状态显示为“已学完”则代表已完成本课程学习。</p><br>
              <p class="pddpdd2"><strong style="font-size:16px;">8.如何申请学分？</strong></p>
              <p class="pddpdd2">
                当学习状态为“已学完”时，方可申请学分；如您尚未绑定学习卡，则无法申请学分，为了您顺利的进行课程学习及证书申请，请先绑定学习卡。</p>
              <br>
              <p class="pddpdd2"><strong style="font-size:16px;">9.为何有些考试完成后看不到成绩？</strong></p>
              <p class="pddpdd2">
                考试后是否能看到成绩是由管理员统一设置的，请与通知您考试的管理员联系或是拨打400-822-2055咨询。</p><br>
              <p class="pddpdd2"><strong style="font-size:16px;">10.每场考试可以考几次？</strong></p>
              <p class="pddpdd2">登录后进入“学习中心”，点击“我的考试”，即可看每场考试的“考试次数”。</p><br>
              <p class="pddpdd2"><strong style="font-size:16px;">11.如何快速找到想学的继续医学教育项目？</strong></p>
              <p class="pddpdd2">
                登录后进入学习中心，即可看到正在开展的继续医学教育培训；可选择推荐项目进行学习，也可通过项目导航搜索您所喜欢的项目进行学习。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer1></footer1>
  </div>
</template>

<script>
import header1 from '../components/Header1'
import footer1 from '../components/Footer1'

export default {
  components: {
    header1,
    footer1
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {
  },
  methods: {}
}
</script>

<style scoped>
/*******************************试用协议页面样式************************************/
.use_xieyi {
  padding-bottom: 20px;
}

.use_xieyi_title {
  font-size: 24px;
  line-height: 70px;
  text-align: center;
}

.use_xieyi_main {
  font-size: 14px;
  line-height: 30px;
  text-align: left;
}

.user_xieyi_close {
  padding-top: 30px;
}

.user_xieyi_close a {
  font-size: 14px;
  line-height: 30px;
  display: block;
  width: 80px;
  height: 30px;
  margin: 0px auto;
  text-align: center;
  color: #FFFFFF;
  background: #0F77CD;
}

p.pddpdd {
  line-height: 24px;
  width: 90%;
  margin: 0px auto;
  padding-bottom: 8px;
  text-align: left;
  text-indent: 2em;
}

p.pddpdd2 {
  line-height: 24px;
  width: 90%;
  margin: 0px auto;
  padding-bottom: 8px;
  text-align: left;
}

p.pddpdd3 {
  line-height: 22px;
  width: 90%;
  margin: 0px auto;
  text-align: left;
  text-indent: 2em;
}

p.pddpdd_img {
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
}

ul.zzzs li {
  text-align: center;
}

ul.zzzs li img {
  display: inline-block;
  margin-right: 40px;
  margin-bottom: 40px;
  padding: 1px;
  border: 5px #E1E1E1 solid;
  border-radius: 5px;
}
</style>




// WEBPACK FOOTER //
// src/views/Help.vue